// import React from 'react';
import Staff from "containers/Staff";
import Dashboard from "containers/Staff/Dashboard";
import EasebuzzSubmerchant from 'containers/Staff/EasebuzzSubmerchant'
import AggregatedRazorpayPayments from "containers/Staff/AggregatedRazorpayPayments";
import WhatsApp from 'containers/Staff/WhatsApp';



export const staffConfig = [
  {
    auth: ['staff'],
    component: Staff,
    path: '/staff',
    routes: [
      {
        component: Dashboard,
        path: '/staff/dashboard'
      },
      {
        component: EasebuzzSubmerchant,
        path: '/staff/easebuzz-submerchant'
      },
      {
        component: AggregatedRazorpayPayments,
        path: '/staff/reports/razorpay-aggregated'
      },
      {
        component: WhatsApp,
        path: '/staff/whatsapp'
      }
    ]

  },
];
